var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLootSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.908 356.021H851.082C878.32 356.021 896.55 327.364 885.515 301.897L819.653 149.911C813.617 135.981 800.119 127 785.221 127H238.769C223.871 127 210.373 135.981 204.337 149.911L138.476 301.897C127.44 327.364 145.67 356.021 172.908 356.021Z",
    fill: "#083342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.33 439.331H836.67C880.963 439.331 915.695 478.227 911.684 523.341L884.665 827.312C881.137 866.991 848.608 897.373 809.65 897.373H214.35C175.392 897.373 142.862 866.991 139.335 827.312L112.315 523.341C108.305 478.227 143.037 439.331 187.33 439.331ZM549.617 576.216L540.471 571.02C529.097 564.557 515.266 564.557 503.891 571.02L494.746 576.216L344.45 661.61C326.267 671.941 319.716 695.391 329.817 713.987L348.108 747.657C358.209 766.253 381.138 772.953 399.321 762.622L503.891 703.207C515.266 696.744 529.097 696.744 540.471 703.207L645.042 762.622C663.224 772.953 686.153 766.253 696.254 747.657L714.545 713.987C724.646 695.391 718.095 671.941 699.912 661.61L549.617 576.216Z",
    fill: "#083342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLootSquare);
export default __webpack_public_path__ + "static/media/Loot-Square.e07c36f15956bd1ecc3bae2ffef7dadf.svg";
export { ForwardRef as ReactComponent };